$(function () {
  let text_counters = new Array();
  let textareas = new Array();

  // 初回読み込み時の処理
  initTextCounter();
  // テンプレート追加時の処理
  $('.add_fields').on('click', function () {
    // フォームが追加されるのを待って実行
    setTimeout(addTextCounter, 10);
  });
  // テンプレート削除時の処理
  removeTextCounter();

  // フォームの文字数カウンター初期化
  function initTextCounter() {
    getForms();
    // 入力フォームを取得できない場合は処理終了
    if (typeof textareas[0] === "undefined") return;
    $.each(text_counters, function () {
      setCounters(this);
    });
    $.each(text_counters, setCharacterLimitCecker);
  }

  function addTextCounter () {
    getForms();
    if (typeof textareas[0] === "undefined") return;
    // 追加されたフォームのカウンターを取得
    text_counters.push($('.text-counter:last'));
    
    setCounters(text_counters[text_counters.length - 1]);
    $.each(text_counters, setCharacterLimitCecker);
  }

  function removeTextCounter () {
    $('.remove_fields').on('click', function () {
      // フォームが削除されるのを待って実行
      setTimeout(initTextCounter, 10);
    });
  }
  
  function getForms () {
    // 全てのtextareaを取得
    textareas = new Array();
    $('.line-single-template-notes').each(function () {
      textareas.push($(this).prevAll('[id$="_body"]'));
    });
  
    text_counters = new Array();
    $('.text-counter').each(function () {
      text_counters.push($(this));
    });
  }

  // カウンター初期化
  function setCounters (text_counter) {
    // 改行は2文字でカウント
    let count = $(text_counter).parent().prevAll('[id$="_body"]').text().replace(/\n/g, '改行').length + 27;

    if (count > 5000) {
      $(text_counter).css('color', 'red');
      $('[type="submit"]').prop('disabled', true);
    } else {
      $(text_counter).css('color', 'black');
      $('[type="submit"]').prop('disabled', false);
    }
    // 初期カウンター
    $(text_counter).text(count + ' / 5000文字');
  }

  // 文字数チェック
  function setCharacterLimitCecker () {
    $(this).parent().prevAll('[id$="_body"]').on('keyup', function () {
      let count = $(this).val().replace(/\n/g, '改行').length + 27;
      if (count > 5000) {
        // カウンターの文字色を赤にする
        $(this).nextAll().children('.text-counter').css('color', 'red');
        $('[type="submit"]').prop('disabled', true);
      } else {
        $(this).nextAll().children('.text-counter').css('color', 'black');
        // 全てのtextareaが制限文字数以内の場合、送信可能に
        if (textareas.every(function (textarea) {
          return $(textarea).val().replace(/\n/g, '改行').length + 27 <= 5000;
        })) {
          $('[type="submit"]').prop('disabled', false);
        }
      }
      // 入力後カウンター
      $(this).nextAll().children('.text-counter').text(count + ' / 5000文字');
    });
  }

});
